import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { CustomerOrganization } from "@/Modules/Models/Domain/User";
import type { CustomerOrganizationApi } from "@/Modules/Models/Api/User";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import { camel } from "@/Utils/Camelize";

const CustomerOrganizationTransformer: TransformerExtended<CustomerOrganization, CustomerOrganizationApi> = {
  ...DefaultTransformerGenerator<CustomerOrganization, CustomerOrganizationApi>(),

  toDomain(input: CustomerOrganizationApi) {
    return camel(input);
  },
};

export type CustomerOrganizationTransformerType = TransformerExtended<
  CustomerOrganization,
  CustomerOrganizationApi
>;

export default CustomerOrganizationTransformer;
